import {captureConsoleIntegration} from '@sentry/integrations';
import {init, replayIntegration} from '@sentry/react';
import {getCachedAuthTokens} from 'src/utils/auth-tokens';

type SentryConfig = {
    sentryDsn?: string,
};

export const initSentry = () => {
    const {accessToken} = getCachedAuthTokens();
    const headers: Record<string, string> = {};
    if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
    }

    fetch('/web-api/sentry-config', {headers: Object.keys(headers).length ? headers : undefined})
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: Failed to fetch Sentry config`);
            }
            return response.text();
        })
        .then(text => {
            if (!text) {
                throw new Error('Empty Sentry config response');
            }
            return JSON.parse(text);
        })
        .then((config: SentryConfig) => {
            if (config?.sentryDsn) {
                init({
                    dsn: config.sentryDsn,
                    replaysOnErrorSampleRate: 0.1,
                    attachStacktrace: true,
                    integrations: [
                        replayIntegration(),
                        captureConsoleIntegration({levels: ['error']}),
                    ],
                    tracesSampleRate: 1,
                });
            }
        })
        .catch((error: Error) => {
            // eslint-disable-next-line no-console
            console.warn('Sentry initialization skipped:', error.message);
        });
};
